<template>
  <div class="documentation">
    <h1 class="title">
      Documentation
    </h1>
    <div class="with-space">
      <h2 class="title is-4">
        Publications
      </h2>
      <ul>
        <li class="with-space">
          <a
            :href="`${publicPath}OHara_2011.pdf`"
            target="_blank"
            rel="noopener noreferrer"
          >Simulation of the undiseased human cardiac ventricular action
            potential: model formulation and experimental validation</a>
          <br>O'Hara, T. et al. PLoS Comput. Biol. 7 <b>2011</b> DOI:
          10.1371/journal.pcbi.1002061
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>

<style scoped>
div.documentation {
  padding-right: 2em;
  line-height: 1.7;
}
</style>
